import { getUshvPimaSpecialCaseConfig } from "@/configuration/groups/ushv-pima/configuration";
import { evaluateSpecialCases } from "@/src/lib/special-cases/evaluate-special-cases";
import type { Referral } from "@/src/models/documents/referral";
import { PatientType } from "@/src/models/patient";
import type { SchedulingRecommendation } from "@/src/models/scheduling-recommendation";

export function buildPimaEscalationActionText(reasonLabel: string, detail?: string): { subject: string; note: string } {
  const subject = `Referral - ${reasonLabel}`;
  const note = detail
    ? `Please schedule referral, the patient is ${reasonLabel}. ${detail}`
    : `Please schedule referral, the patient is ${reasonLabel}.`;

  return { subject, note };
}

export function getPimaAppointmentReason(
  referral: Referral,
  chartEligibilityCheck?: Pick<NonNullable<SchedulingRecommendation["chartEligibilityCheck"]>, "classification"> | null
): string {
  const isEstablished = chartEligibilityCheck
    ? chartEligibilityCheck.classification === "established"
    : referral.patient.type === PatientType.ESTABLISHED;

  if (isEstablished) {
    return "Established Patient";
  }

  const config = getUshvPimaSpecialCaseConfig();
  const specialCases = evaluateSpecialCases(referral, referral.patient, config);

  return specialCases.includes("Insurance Consult Needed") ? "Consult" : "New Patient";
}
